import { cn } from '../../utils/classNames';
import { TOUR_TARGETS } from '../../constants/tourTargets';
import XButton from '../common/XButton';
import IntegratorModal from '../ui-control/IntegratorModal';
import TooltipWrapper from '../ui-control/TooltipWrapper';
import EasyModePartnerCaseList from './EasyModePartnerCaseList';
import {
  EASY_MODE_PARTNER_BUTTON_CLASSES,
  importBannerClasses,
  partnerButtonBaseClasses,
  partnerButtonRowClasses,
  partnerHeaderClasses,
  partnerPanelClasses,
  partnerQuestionClasses,
  partnerSubtitleClasses
} from './easyModeClasses';

const EasyModePartnerImport = ({
  caseId,
  partners,
  isExpanded,
  selectedPartner,
  selectedCase,
  isAutoImporting,
  importedPartnerLabel,
  partnerLabel,
  partnerCases,
  onToggleExpanded,
  onSelectPartner,
  onClearPartner,
  onSelectCase,
  onCloseConfirmation,
  onImported,
  onDismissBanner
}) => {
  // no key, no partner to import from, so the whole prompt stays hidden
  if (!partners.length) return null;

  return (
  <>
    <div className={partnerPanelClasses} data-tour={TOUR_TARGETS.EASY_MODE_PARTNER_IMPORT}>
      <div className={partnerHeaderClasses}>
        <span className={partnerQuestionClasses}>
          Already have a case in your management system?
        </span>
        <XButton variant="link" onClick={onToggleExpanded}>
          {isExpanded ? 'Hide' : 'Import Case'}
        </XButton>
      </div>

      {isExpanded && !selectedPartner && (
        <>
          <p className={partnerSubtitleClasses}>
            Pulls case type, incident date, parties, and documents automatically.
          </p>
          <div className={partnerButtonRowClasses}>
            {partners.map(({ value, text, isAvailable, unavailableReason }) => (
              <TooltipWrapper
                key={value}
                showTooltip={!isAvailable}
                title={unavailableReason}
                variant="info"
              >
                <span>
                  <button
                    type="button"
                    className={cn(
                      partnerButtonBaseClasses,
                      EASY_MODE_PARTNER_BUTTON_CLASSES[value],
                      'w-full'
                    )}
                    disabled={!isAvailable}
                    onClick={() => onSelectPartner({ partner: value })}
                  >
                    {text}
                  </button>
                </span>
              </TooltipWrapper>
            ))}
          </div>
        </>
      )}

      {isExpanded && selectedPartner && (
        <EasyModePartnerCaseList
          partnerLabel={partnerLabel}
          cases={partnerCases.cases}
          isLoading={partnerCases.isLoading}
          pageNumber={partnerCases.pageNumber}
          totalPages={partnerCases.totalPages}
          totalCount={partnerCases.totalCount}
          hasNextPage={partnerCases.hasNextPage}
          hasPreviousPage={partnerCases.hasPreviousPage}
          onSearch={partnerCases.searchFor}
          onSelectCase={onSelectCase}
          onNextPage={partnerCases.goToNextPage}
          onPreviousPage={partnerCases.goToPreviousPage}
          onBack={onClearPartner}
        />
      )}
    </div>

    <IntegratorModal
      caseId={caseId}
      selectedCase={selectedCase}
      selectedPartner={selectedPartner}
      isAutoImporting={isAutoImporting}
      onClose={onCloseConfirmation}
      onImported={onImported}
    />

    {importedPartnerLabel && (
      <div className={importBannerClasses}>
        <span>
          {`Imported case details from ${importedPartnerLabel}. Review them on Case Intake.`}
        </span>
        <XButton variant="link" onClick={onDismissBanner}>
          Dismiss
        </XButton>
      </div>
    )}
  </>
  );
};

export default EasyModePartnerImport;
